// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuoteListComponent } from "./quote-list.component";
import { QuoteFilterModule } from "./components/quote-filter/quote-filter.module";
import { QuoteListContainerModule } from "./components/quote-list-container/quote-list-container.module";
import { CardModule } from "libraries/ui_card/card.module";
import { AirTripResourceModule } from "libraries/service/resources/airTrip/airTripResource.module";
import { NotificationModule } from "libraries/component/notification/notification.module";
import { LoaderModule } from "libraries/component/loader/loader.module";
import { FilterServiceModule } from './services/filter/filter-service.module';
import { QuoteResultModule } from "app_locobook/pages/quote-page/components/quote-result/quote-result.module";
import { PropalModule } from 'app_locobook/service/propal/propal.module';

@NgModule({
    imports: [
        AirTripResourceModule,
        CardModule,
        CommonModule,
        LoaderModule,
        NotificationModule,
        QuoteListContainerModule,
        QuoteFilterModule,
        FilterServiceModule,
        QuoteResultModule,
        PropalModule,
    ],
    declarations: [
        QuoteListComponent
    ],
    exports: [
        QuoteListComponent
    ],
})
export class QuoteListModule { }